import React from "react";
import { FaArrowRight } from "react-icons/fa";
import "../styles/ImpactSection.css";

function ImpactCard({
  imageSrc,
  imageAlt,
  title,
  body,
  ctaText,
  ctaHref = "#",
}) {
  return (
    <article className="impact-card" role="article">
      <img className="impact-card__img" src={imageSrc} alt={imageAlt} />
      <div className="impact-card__body">
        <h3 className="impact-card__title">{title}</h3>
        <p className="impact-card__text">{body}</p>
        <a className="impact-card__btn" href={ctaHref}>
          {ctaText} <FaArrowRight aria-hidden />
        </a>
      </div>
    </article>
  );
}

export default function ImpactSection({ onDonate }) {
  const handleDonateClick = (e) => {
    e.preventDefault();
    if (typeof onDonate === "function") {
      onDonate();
    }
  };

  return (
    <section
      id="impact"
      className="impact-section"
      aria-labelledby="impact-heading"
    >
      <div className="impact-inner">
        <h2 id="impact-heading" className="impact-heading">
          How We Will Make an Impact
        </h2>

        <div className="impact-grid">
          <ImpactCard
            imageSrc="/img/jax.png"
            imageAlt="Researchers collaborating in a lab"
            title="Fund Alzheimer’s Research"
            body="We’ll direct a portion of funds to Jackson Laboratory to accelerate research into early Alzheimer’s detection using retinal biomarkers to spot disease signals years before symptoms. By backing this work in Maine, we aim to help move promising lab findings into practical screening tools for patients and families."
            ctaText="About the JAX partnership"
            ctaHref="/impact/JAX"
          />

          <ImpactCard
            imageSrc="/img/club.jpeg"
            imageAlt="Caregiver supporting a resident at a senior home"
            title="Support Respite Care (The Club)"
            body="We’re proud to support Bath–Brunswick Respite Care’s Adult Day Program, where daily conversation and social activities stimulate cognition in a warm, comfortable setting. Your gift sustains these interactions and gives family caregivers reliable time to rest and recharge."
            ctaText='About "The Club"'
            ctaHref="/impact/respite"
          />

          <ImpactCard
            imageSrc="/img/baseball.jpeg"
            imageAlt="Bowdoin Baseball players celebrating"
            title="Bowdoin Baseball Team"
            body="Follow @bowdoinbaseball to track the fundraiser’s progress and hear each teammate share a favorite memory with a loved one affected by Alzheimer’s."
            ctaText="Follow on Instagram"
            ctaHref="https://www.instagram.com/bowdoinbaseball/?hl=en"
          />
        </div>

        <div
          className="impact-cta"
          role="group"
          aria-label="Donate call to action"
        >
          <p className="impact-cta__tagline">
            Your support powers research and care.
          </p>
          <p className="impact-cta__tagline">
            Together we can help stop Alzheimer’s
          </p>

          <a
            href="#donate"
            onClick={handleDonateClick}
            className="impact-cta__button"
            aria-label="Donate now"
          >
            Donate Now
          </a>
        </div>
      </div>
    </section>
  );
}
